import * as types from '../constant/actionTypes'

export const setPaymentInfo = (info) => {
    return {
        type: types.SET_PAYMENT_INFO,
        payload: info
    }
}
